export const storageKeys = {
  storageKey: {
    usuarioCapiro: 'CAPIRO-WEB::usuario',
    tokenCapiro: 'CAPIRO-WEB::token',
    infoGeneralArrendar: 'CAPIRO-WEB::informacion-general-arrendar',
    infoOcupacionArrendar: 'CAPIRO-WEB::informacion-ocupacion-arrendar',
    infoReferenciasArrendar: 'CAPIRO-WEB::referencias-arrendar',
    infoBienesArrendar: 'CAPIRO-WEB::bienes-arrendar',
    idInmuebleArriendo: 'CAPIRO-WEB::idInmueble',
  },
};

export const parametrosSelect = {
  tiposInmuebles: [
    {
      value: 'Casa',
      label: 'Casa',
    },
    {
      value: 'Apartamento',
      label: 'Apartamento',
    },
    {
      value: 'Local',
      label: 'Local',
    },
    {
      value: 'Bodega',
      label: 'Bodega',
    },
    {
      value: 'Casa Finca',
      label: 'Casa Finca',
    },
    {
      value: 'Lote',
      label: 'Lote',
    },
  ],
  listaEstratos: [
    {
      value: '0',
      label: 'N/A',
    },
    {
      value: '1',
      label: 'Estrato 1',
    },
    {
      value: '2',
      label: 'Estrato 2',
    },
    {
      value: '3',
      label: 'Estrato 3',
    },
    {
      value: '4',
      label: 'Estrato 4',
    },
    {
      value: '5',
      label: 'Estrato 5',
    },
    {
      value: '6',
      label: 'Estrato 6',
    },
    {
      value: '7',
      label: 'Estrato 7',
    },
  ],
  listaHabitaciones: [
    {
      value: '0',
      label: 'N/A',
    },
    {
      value: '1',
      label: '1 Habitación',
    },
    {
      value: '2',
      label: '2 Habitaciones',
    },
    {
      value: '3',
      label: '3 Habitaciones',
    },
    {
      value: '4',
      label: '4 Habitaciones',
    },
    {
      value: '5',
      label: '5 Habitaciones',
    },
    {
      value: '6',
      label: '6 Habitaciones',
    },
    {
      value: '7',
      label: '7 Habitaciones',
    },
  ],
  listaEleccionSiNo: [
    {
      value: 'Si',
      label: 'Sí',
    },
    {
      value: 'No',
      label: 'No',
    },
  ],
  estadoInmueble: [
    {
      value: 'Nuevo',
      label: 'Nuevo',
    },
    {
      value: 'Usado',
      label: 'Usado',
    },
  ],
  tipoPublicacion: [
    {
      value: 'Arriendo',
      label: 'Arriendo',
    },
    {
      value: 'Venta',
      label: 'Venta',
    },
  ],
  tipoConstruccion: [
    {
      value: 'Sin Tipo',
      label: 'Sin Tipo',
    },
    {
      value: 'Moderno',
      label: 'Moderno',
    },
    {
      value: 'Antiguo',
      label: 'Antiguo',
    },
  ],
  tiposDocumentos: [
    {
      value: 'Cédula de ciudadanía',
      label: 'Cédula de ciudadanía',
    },
    {
      value: 'Cédula de extranjería',
      label: 'Cédula de extranjería',
    },
    {
      value: 'Pasaporte',
      label: 'Pasaporte',
    },
  ],
  listaSexos: [
    {
      value: 'Masculino',
      label: 'Masculino',
    },
    {
      value: 'Femenino',
      label: 'Femenino',
    },
    {
      value: 'Otro',
      label: 'Otro',
    },
  ],
  listaNivelEstudio: [
    {
      value: 'Primaria',
      label: 'Primaria',
    },
    {
      value: 'Bachiller',
      label: 'Bachiller',
    },
    {
      value: 'Técnico',
      label: 'Técnico',
    },
    {
      value: 'Tecnólogo',
      label: 'Tecnólogo',
    },
    {
      value: 'Universitario',
      label: 'Universitario',
    },
    {
      value: 'Ninguno',
      label: 'Ninguno',
    },
  ],
  listadoEstadosCivil: [
    {
      value: 'Soltero',
      label: 'Soltero',
    },
    {
      value: 'Casado',
      label: 'Casado',
    },
  ],
  listaOcupacion: [
    {
      value: 'Empleado',
      label: 'Empleado',
    },
    {
      value: 'Independiente',
      label: 'Independiente',
    },
    {
      value: 'Pensionado',
      label: 'Pensionado',
    },
  ],
  tiposCuentasBancos: [
    {
      value: 'Cuenta de Ahorros',
      label: 'Cuenta de Ahorros',
    },
    {
      value: 'Cuenta de Corriente',
      label: 'Cuenta de Corriente',
    },
  ],
  listaNiveles: [
    {
      value: '0',
      label: 'N/A',
    },
    {
      value: '1',
      label: 'Nivel 1',
    },
    {
      value: '2',
      label: 'Nivel 2',
    },
    {
      value: '3',
      label: 'Nivel 3',
    },
    {
      value: '4',
      label: 'Nivel 4',
    },
    {
      value: '5',
      label: 'Nivel 5',
    },
    {
      value: '6',
      label: 'Nivel 6',
    },
  ],
  listaBanios: [
    {
      value: '0',
      label: 'N/A',
    },
    {
      value: '1',
      label: '1 Baño',
    },
    {
      value: '2',
      label: '2 Baños',
    },
    {
      value: '3',
      label: '3 Baños',
    },
    {
      value: '4',
      label: '4 Baños',
    },
    {
      value: '5',
      label: '5 Baños',
    },
    {
      value: '6',
      label: '6 Baños',
    },
  ],
  listaCloseth: [
    {
      value: '0',
      label: 'N/A',
    },
    {
      value: '1',
      label: '1 Closet',
    },
    {
      value: '2',
      label: '2 Closet',
    },
    {
      value: '3',
      label: '3 Closet',
    },
    {
      value: '4',
      label: '4 Closet',
    },
    {
      value: '5',
      label: '5 Closet',
    },
    {
      value: '6',
      label: '6 Closet',
    },
  ],
  listaUsoPropiedad: [
    {
      value: 'Residencial',
      label: 'Residencial',
    },
    {
      value: 'Comercial',
      label: 'Comercial',
    },
    {
      value: 'Mixto',
      label: 'Mixto',
    },
    {
      value: 'Otro',
      label: 'Otro',
    },
  ],
  listaDepartamentos: [
    {
      value: 'Antioquia',
      label: 'Antioquia',
    },
  ],
  tipoCocina: [
    {
      value: 'Sin Tipo',
      label: 'Sin Tipo',
    },
    {
      value: 'Integral',
      label: 'Integral',
    },

    {
      value: 'Sencilla',
      label: 'Sencilla',
    },

    {
      value: 'Semi integral',
      label: 'Semi integral',
    },
  ],
  listaNegociado: [
    {
      value: 'ARRENDADO',
      label: 'ARRENDADO',
    },
    {
      value: 'VENDIDO',
      label: 'VENDIDO',
    },
    {
      value: 'SIN NEGOCIAR',
      label: 'SIN NEGOCIAR',
    },
  ],
};

export const requisitosPropiedades = {
  arriendoPropiedadImg: './assets/images/arriendo-capiro.png',
  ventaPropiedadImg: './assets/images/venta-capiro.png',
};

export const validacionPatterns = {
  soloNumeros: '^([0-9])*$',
};

export const nombresDocumentosAvaluoHipoteca = {
  nombresAvaluoDocumentos: ['Certificado de libertad', 'Escritura pública', 'Predial', 'Certificado catastral'],
  nombresHipotecaDocumentos: ['Cédula', 'Escritura', 'Certificado de libertad y tradicción', 'Predial', 'Certificado catastral'],
};

export const parametrosInmuebles = {
  postMaxUploadPhoto: 15,
};
